import { Component, OnInit } from "@angular/core";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
// import { childRoutes } from '../../child-routes';

@Component({
  selector: "app-side-nav-closed",
  templateUrl: "./side-nav-closed.component.html",
  styleUrls: ["./side-nav-closed.component.scss"],
  imports: [MatListModule, MatIconModule, RouterModule,CommonModule],
  standalone: true,
})
export class SideNavClosedComponent implements OnInit {
  routes: any[] = [
    {
            path: "updatePrice",
            data: { icon: "price_change", text: "Update Price" }
          },
          {
            path: "user",
            data: { icon: "person_add", text: "Create User" }
          },{
            path: "recordPayment",
            data: { icon: "payment", text: "Record Payment" }
          },{
            path: 'download-receipt',
            data: { icon: "download", text: "Download Receipt" }
          }
  ];
  constructor() {}

  ngOnInit(): void {}
}
